module.exports = __webpack_public_path__ + "static/media/search_icon.b1eb13e2.svg";